<template>
  <tr>
    <td>{{ mentoria.alumno.nombre }} {{ mentoria.alumno.apellido }}</td>
    <td>{{ mentoria.mentor.nombre }} {{ mentoria.mentor.apellido }}</td>
    <td>{{ fecha(mentoria.fecha_inicio) }}</td>
    <td>
      <span v-if="mentoria.fecha_finalizacion == null"></span>
      <span v-else >{{ fecha(mentoria.fecha_finalizacion) }}</span>
    </td>
    <td>{{ mentoria.condicion.nombre }}</td>
    <td>{{ mentoria.comentario_final_mentor }}</td>
    <td>{{ mentoria.comentario_aayi }}</td>
    <td>
      <button @click="mostrarModal(1)" class="boton_editar_password boton_editar_password_2">Editar</button>
      <div class="contenedor_editar_password"
        v-if="mostrarEditarCondicion"
      >
        <div class="contenedor_form_editar_password">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <form
            action="#"
            @submit.prevent="editarMentoria(cambio, mentoria.mentoria_id)"
            class="form_editar_password"
            ref="modalRef"
          >
            <div class="form_section_editar_password contenedor-ojo">
              <label for="condiciones_mentoria_id">Condición</label>
              <select
                name="condiciones_mentoria_id"
                id="condiciones_mentoria_id"
                class="form minimal"
                v-model="cambio.condiciones_mentoria_id"
              >
                <option
                  :value="1"
                >
                  Pendiente
                </option>
                <option
                  :value="2"
                >
                  Aceptada
                </option>
                <option
                  :value="3"
                >
                  Rechazada
                </option>
              </select>
            </div>
            <div class="form_section_editar_password contenedor-ojo">
              <label for="fecha_inicio">Fecha de Inicio</label>
              <input
                type="date"
                name="fecha_inicio"
                id="fecha_inicio"
                v-model="cambio.fecha_inicio"
              >
            </div>
            <div class="form_section_editar_password contenedor-ojo">
              <label for="comentario_aayi">Observaciones</label>
              <textarea
                name="comentario_aayi"
                id="comentario_aayi"
                v-model="cambio.comentario_aayi"
              ></textarea>
            </div>
            <button type="submit">Cargar</button>
          </form>
        </div>
      </div>
    </td>
    <td>
      <button @click="mostrarModal(2)" class="boton_editar_password boton_editar_password_2">Borrar</button>
      <div class="contenedor_editar_password"
        v-if="mostrarMensajeBorrar"
      >
        <div class="contenedor_form_borrar_direccion">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <div
            class="contenedor_botones_modal_borrar_direccion"
            ref="modalRef"
          >
            <div class="contenedor_botones_modal_borrar_direccion_texto">
              <P>¿Estas seguro que deseas borrar la metoría?</P>
              <p>Mentor: {{ mentoria.mentor.nombre }} {{ mentoria.mentor.apellido }}</p>
              <p>Mentoreado: {{ mentoria.alumno.nombre }} {{ mentoria.alumno.apellido }}</p>
            </div>
            <button @click="cerrarModalFinalizarMentoria()" class="boton_cancelar boton_borrar_direccion">CANCELAR</button>
            <button @click="borrarMentoria(mentoria.mentoria_id)" class="boton_aceptar boton_borrar_direccion">SI, BORRAR</button>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
// import examenService from '../services/examen'
// import BaseLoader4 from '../components/BaseLoader4.vue'
import mentorService from '../services/mentor'
export default {
  name: 'MentoriasListaItem',
  components: {
    // BaseLoader4
  },
  props: ['mentoria'],
  data: function () {
    return {
      mostrarEditarCondicion: false,
      mostrarMensajeBorrar: false,
      cambio: {
        condiciones_mentoria_id: null,
        comentario_aayi: null,
        fecha_inicio: null
      }
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    mostrarModal (id) {
      if (id === 1) {
        this.mostrarEditarCondicion = true
      } else {
        this.mostrarMensajeBorrar = true
      }
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    closeModalOnClickOutside (event) {
      const modal = this.$refs.modalRef
      if (!modal.contains(event.target)) {
        console.log('wewewwewew')
        this.cerrarModalFinalizarMentoria()
      }
    },
    cerrarModalFinalizarMentoria () {
      console.log('222tttt222')
      document.removeEventListener('mouseup', this.closeModalOnClickOutside)
      // this.mostrarFinalizarMentoria = false

      // saco el overflow del body
      const body = document.body
      body.style.overflow = 'auto'
      this.mostrarEditarCondicion = false
      this.mostrarMensajeBorrar = false
      this.cambio = {
        condiciones_mentoria_id: this.mentoria.condiciones_mentoria_id,
        comentario_aayi: this.mentoria.comentario_aayi,
        fecha_inicio: this.mentoria.fecha_inicio
      }
      // location.reload()
    },
    editarMentoria (cambio, id) {
      console.log(cambio)
      console.log(id)
      mentorService
        .editarMentoria(cambio, id)
        .then(respuesta => {
          this.cargando = false
          console.log(respuesta)
          if (respuesta.success) {
            this.$emit('refrescar')
            this.cerrarModalFinalizarMentoria()
          } else {
          }
        })
    },
    borrarMentoria (id) {
      console.log(id)
      mentorService
        .borrarMentoria(id)
        .then(respuesta => {
          this.cargando = false
          console.log(respuesta)
          if (respuesta.success) {
            this.$emit('refrescar')
            this.cerrarModalFinalizarMentoria()
          } else {
          }
        })
    }
  },
  mounted: function () {
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.cerrarModalFinalizarMentoria()
      }
    })
    this.cambio = {
      condiciones_mentoria_id: this.mentoria.condiciones_mentoria_id,
      comentario_aayi: this.mentoria.comentario_aayi,
      fecha_inicio: this.mentoria.fecha_inicio
    }
  }
}
</script>

<style>

</style>
